import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { reservaService } from "../../../services/buscarReservaService";
// --------------------- Import Interfaces ---------------------

import { Reserva } from "../../../interfaces/Reserva";

export const useBuscarReservas = () => {
  const [reservas, setReservas] = useState<number>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const data: Reserva[] = await reservaService(); // Definindo o tipo

      const reservasSemPeriodo = data.filter(
        (reserva) => !reserva.PeriodoUsuario
      );

      setReservas(reservasSemPeriodo.length);
      setIsLoading(false);
    };

    fetch();
  }, []);

  return { reservas, isLoading };
};
